import { render, staticRenderFns } from "./windowReCom.vue?vue&type=template&id=0b547fc6&"
import script from "./windowReCom.vue?vue&type=script&lang=js&"
export * from "./windowReCom.vue?vue&type=script&lang=js&"
import style0 from "./windowReCom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "windowReCom.vue"
export default component.exports